import { createAction, props } from '@ngrx/store';

import { Screen } from '@core/interfaces';

import { ErrorResponse } from '#types/core';
import { Filters, SelectedRow, Sorts } from '#types/grid';
import {
  InventoryInquiryResponseBody,
  InventoryInquiryResponseRow,
  InventoryItemDetailResponseBody,
  InventoryItemDetailResponseRow,
  InventoryItemLotResponseBody,
} from '#types/inventory';
import { MultipleListOfValuesResponse } from '#types/list';

//
// inventory / request lists
//

export const RequestLists = createAction('[Inventory] - Request Lists');

//
// inventory lists
//

export const RequestInventoryLists = createAction('[Inventory.Lists] - Request Inventory Lists');
export const RequestInventoryListsSuccess = createAction(
  '[Inventory.Lists] - Request Inventory Lists Success',
  props<{ lists: MultipleListOfValuesResponse }>()
);
export const RequestInventoryListsFailure = createAction(
  '[Inventory.Lists] - Request Inventory Lists Failure',
  props<{ error: ErrorResponse }>()
);

//
// inventory / inquiry
//

export const InquiryInitialize = createAction('[Inventory.Inquiry] - Initialize', props<{ screen: Screen }>());

export const InquiryRequestData = createAction('[Inventory.Inquiry] - Grid Request Data', props<{ id: string }>());

export const InquiryRequestDataWithParameters = createAction(
  '[Inventory.Inquiry] - Grid Request Data With Parameters',
  props<{ id: string; filters: Filters; page: number; first: number; rows: number; sorts: Sorts }>()
);

export const InquiryRequestDataWithFilters = createAction(
  '[Inventory.Inquiry] - Grid Request Data With Filters',
  props<{ id: string; filters: Filters }>()
);

export const InquiryRequestDataForExport = createAction(
  '[Inventory.Inquiry] - Grid Request Data For Export',
  props<{ id: string; format: string; rows: number }>()
);

export const InquiryRequestDataSuccess = createAction(
  '[Inventory.Inquiry] - Grid Request Data Success',
  props<{ id: string; data: InventoryInquiryResponseBody }>()
);

export const InquiryRequestDataFailure = createAction('[Inventory.Inquiry] - Grid Request Data Failure', props<{ id: string }>());

//
// inventory / item detail
//

export const ItemDetailInitialize = createAction('[Inventory.Inquiry.Item-Detail] - Initialize', props<{ screen: Screen }>());

export const ItemDetailRequestData = createAction('[Inventory.Inquiry.Item-Detail] - Grid Request Data', props<{ id: string }>());

export const ItemDetailRequestDataWithParameters = createAction(
  '[Inventory.Inquiry.Item-Detail] - Grid Request Data With Parameters',
  props<{ id: string; filters: Filters; page: number; first: number; rows: number; sorts: Sorts }>()
);

export const ItemDetailRequestDataWithFilters = createAction(
  '[Inventory.Inquiry.Item-Detail] - Grid Request Data With Filters',
  props<{ id: string; filters: Filters }>()
);

export const ItemDetailRequestDataForExport = createAction(
  '[Inventory.Inquiry.Item-Detail] - Grid Request Data For Export',
  props<{ id: string; format: string; rows: number }>()
);

export const ItemDetailRequestDataSuccess = createAction(
  '[Inventory.Inquiry.Item-Detail] - Grid Request Data Success',
  props<{ id: string; data: InventoryItemDetailResponseBody }>()
);

export const ItemDetailRequestDataFailure = createAction(
  '[Inventory-Item.Detail] - Grid Request Data Failure',
  props<{ id: string; data: null }>()
);

export const ItemDetailSetData = createAction(
  '[Inventory.Inquiry.Item-Detail] - Set Item Detail Data',
  props<{ data: SelectedRow<InventoryInquiryResponseRow> }>()
);

export const ItemDetailClearData = createAction('[Inventory-Item.Detail] - Clear Item Detail Data');

//
// inventory / lot detail
//

export const LotDetailInitialize = createAction('[Inventory.Inquiry.Lot-Detail] - Initialize', props<{ screen: Screen }>());

export const LotDetailRequestData = createAction('[Inventory.Inquiry.Lot-Detail] - Grid Request Data', props<{ id: string }>());

export const LotDetailRequestDataWithParameters = createAction(
  '[Inventory.Inquiry.Lot-Detail] - Grid Request Data With Parameters',
  props<{ id: string; filters: Filters; page: number; first: number; rows: number; sorts: Sorts }>()
);

export const LotDetailRequestDataWithFilters = createAction(
  '[Inventory.Inquiry.Lot-Detail] - Grid Request Data With Filters',
  props<{ id: string; filters: Filters }>()
);

export const LotDetailRequestDataForExport = createAction(
  '[Inventory.Inquiry.Lot-Detail] - Grid Request Data For Export',
  props<{ id: string; format: string; rows: number }>()
);

export const LotDetailRequestDataSuccess = createAction(
  '[Inventory.Inquiry.Lot-Detail] - Grid Request Data Success',
  props<{ id: string; data: InventoryItemLotResponseBody }>()
);

export const LotDetailRequestDataFailure = createAction(
  '[Inventory.Inquiry.Lot-Detail] - Grid Request Data Failure',
  props<{ id: string; data: null }>()
);

export const LotDetailSetData = createAction(
  '[Inventory.Inquiry.Lot-Detail] - Set Lot Detail Data',
  props<{ data: SelectedRow<InventoryItemDetailResponseRow> }>()
);

export const LotDetailClearData = createAction('[Inventory.Inquiry.Lot-Detail] - Clear Lot Detail Data');
